/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Authentication api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AcquaintanceMethod } from '../model';
// @ts-ignore
import { AddUserNoteRequest } from '../model';
// @ts-ignore
import { AddUserRequest } from '../model';
// @ts-ignore
import { AdminUpdateUserResponse } from '../model';
// @ts-ignore
import { BlocklistUserResponse } from '../model';
// @ts-ignore
import { DomesticCityDto } from '../model';
// @ts-ignore
import { GroupsResponse } from '../model';
// @ts-ignore
import { Int32ResourceCreated } from '../model';
// @ts-ignore
import { OrgType } from '../model';
// @ts-ignore
import { ProvinceDto } from '../model';
// @ts-ignore
import { RegisterRequest } from '../model';
// @ts-ignore
import { SendMessageRequest } from '../model';
// @ts-ignore
import { SortColumns } from '../model';
// @ts-ignore
import { StaffUsersResponse } from '../model';
// @ts-ignore
import { UpdateUserRequest } from '../model';
// @ts-ignore
import { UpdateUserResponse } from '../model';
// @ts-ignore
import { UserFcmTokenRequest } from '../model';
// @ts-ignore
import { UserNoteResponse } from '../model';
// @ts-ignore
import { UserSearchViewPagedResponse } from '../model';
// @ts-ignore
import { UserSite } from '../model';
// @ts-ignore
import { UserStatusRequest } from '../model';
// @ts-ignore
import { UserType } from '../model';
// @ts-ignore
import { UserView } from '../model';
// @ts-ignore
import { WhyMrBilit } from '../model';
/**
 * UserApiApiAdminUsersGet - axios parameter creator
 * 
 * @summary  (Auth policies: Aut:GetUser)
 * @param {number} userId 
 * @param {boolean} [includePermissions] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiAdminUsersGetAxiosParamCreator (userId: number, includePermissions?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiAdminUsersGet', 'userId', userId)
    const localVarPath = `/api/admin/users`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }

    if (includePermissions !== undefined) {
        localVarQueryParameter['includePermissions'] = includePermissions;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiAssociateUUIDGet - axios parameter creator
 * 
 * @param {string} [uuid] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiAssociateUUIDGetAxiosParamCreator (uuid?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AssociateUUID`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (uuid !== undefined) {
        localVarQueryParameter['uuid'] = uuid;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiChangeUserPatch - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {number} [userId] 
 * @param {RegisterRequest} [registerRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiChangeUserPatchAxiosParamCreator (userId?: number, registerRequest?: RegisterRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/ChangeUser`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiGetAcquaintanceMethodsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiGetAcquaintanceMethodsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetAcquaintanceMethods`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiGetAssociatedUUIDsGet - axios parameter creator
 * 
 * @summary  (Auth policies: aut:GetAssociatedGuids)
 * @param {string} [uuid] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiGetAssociatedUUIDsGetAxiosParamCreator (uuid?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetAssociatedUUIDs`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (uuid !== undefined) {
        localVarQueryParameter['uuid'] = uuid;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiGetDomesticCitiesProvinceIdGet - axios parameter creator
 * 
 * @param {number} provinceId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiGetDomesticCitiesProvinceIdGetAxiosParamCreator (provinceId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'provinceId' is not null or undefined
    assertParamExists('apiGetDomesticCitiesProvinceIdGet', 'provinceId', provinceId)
    const localVarPath = `/api/GetDomesticCities/{provinceId}`
        .replace(`{${"provinceId"}}`, encodeURIComponent(String(provinceId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiGetProvincesGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiGetProvincesGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetProvinces`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiGetWhyMrBilitGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiGetWhyMrBilitGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetWhyMrBilit`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiGetuserGet - axios parameter creator
 * 
 * @param {number} [userId] 
 * @param {boolean} [includePermissions] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiGetuserGetAxiosParamCreator (userId?: number, includePermissions?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/getuser`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }

    if (includePermissions !== undefined) {
        localVarQueryParameter['includePermissions'] = includePermissions;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiGroupsGet - axios parameter creator
 * 
 * @summary  (Auth policies: auth:ReadGroups)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiGroupsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/groups`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiSetUserAttributesGet - axios parameter creator
 * 
 * @param {string} [mobile] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiSetUserAttributesGetAxiosParamCreator (mobile?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SetUserAttributes`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobile !== undefined) {
        localVarQueryParameter['mobile'] = mobile;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUserBlocklistGet - axios parameter creator
 * 
 * @summary Get all blocklist users (Auth policies: Auth:BlockUser)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUserBlocklistGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/User/blocklist`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUserIdStatusPut - axios parameter creator
 * 
 * @summary enable or disable a user.  if not stated will toggle the user\'s state (Auth policies: auth:ChangeUserStatus)
 * @param {number} id 
 * @param {UserStatusRequest} [userStatusRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUserIdStatusPutAxiosParamCreator (id: number, userStatusRequest?: UserStatusRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiUserIdStatusPut', 'id', id)
    const localVarPath = `/api/user/{id}/status`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(userStatusRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUserPost - axios parameter creator
 * 
 * @summary creating a new user (Auth policies: auth:UserCreation)
 * @param {AddUserRequest} [addUserRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUserPostAxiosParamCreator (addUserRequest?: AddUserRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/user`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addUserRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUserSendMessagePost - axios parameter creator
 * 
 * @summary Sets fcm token for the user (Auth policies: auth:SendMessageToUser)
 * @param {SendMessageRequest} [sendMessageRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUserSendMessagePostAxiosParamCreator (sendMessageRequest?: SendMessageRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/user/sendMessage`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(sendMessageRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUserSetFcmTokenPut - axios parameter creator
 * 
 * @summary Sets fcm token for the user (Auth)
 * @param {UserFcmTokenRequest} [userFcmTokenRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUserSetFcmTokenPutAxiosParamCreator (userFcmTokenRequest?: UserFcmTokenRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/user/setFcmToken`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(userFcmTokenRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUserUserIdBlocklistPatch - axios parameter creator
 * 
 * @summary Block or unblock a user (Auth policies: Auth:BlockUser)
 * @param {number} userId 
 * @param {boolean} [isBlocklist] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUserUserIdBlocklistPatchAxiosParamCreator (userId: number, isBlocklist?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiUserUserIdBlocklistPatch', 'userId', userId)
    const localVarPath = `/api/User/{userId}/blocklist`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (isBlocklist !== undefined) {
        localVarQueryParameter['IsBlocklist'] = isBlocklist;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUserUserIdPut - axios parameter creator
 * 
 * @summary  (Auth policies: auth:AdminUserUpdate)
 * @param {number} userId 
 * @param {UpdateUserRequest} [updateUserRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUserUserIdPutAxiosParamCreator (userId: number, updateUserRequest?: UpdateUserRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiUserUserIdPut', 'userId', userId)
    const localVarPath = `/api/user/{userId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUsersOrganizationUserSearchGet - axios parameter creator
 * 
 * @summary  (Auth policies: auth:OrganizationUserSearch)
 * @param {string} [mobile] 
 * @param {string} [title] 
 * @param {boolean} [active] 
 * @param {SortColumns} [sortColumn] 
 * @param {boolean} [sortByAsc] 
 * @param {OrgType} [organizationType] 
 * @param {number} [page] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUsersOrganizationUserSearchGetAxiosParamCreator (mobile?: string, title?: string, active?: boolean, sortColumn?: SortColumns, sortByAsc?: boolean, organizationType?: OrgType, page?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/users/OrganizationUserSearch`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobile !== undefined) {
        localVarQueryParameter['Mobile'] = mobile;
    }

    if (title !== undefined) {
        localVarQueryParameter['Title'] = title;
    }

    if (active !== undefined) {
        localVarQueryParameter['Active'] = active;
    }

    if (sortColumn !== undefined) {
        localVarQueryParameter['SortColumn'] = sortColumn;
    }

    if (sortByAsc !== undefined) {
        localVarQueryParameter['SortByAsc'] = sortByAsc;
    }

    if (organizationType !== undefined) {
        localVarQueryParameter['OrganizationType'] = organizationType;
    }

    if (page !== undefined) {
        localVarQueryParameter['Page'] = page;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUsersSearchGet - axios parameter creator
 * 
 * @summary  (Auth policies: auth:UserSearch)
 * @param {string} [mobile] 
 * @param {string} [mail] 
 * @param {string} [title] 
 * @param {number} [groupId] 
 * @param {number} [siteId] 
 * @param {boolean} [active] 
 * @param {number} [page] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUsersSearchGetAxiosParamCreator (mobile?: string, mail?: string, title?: string, groupId?: number, siteId?: number, active?: boolean, page?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/users/search`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobile !== undefined) {
        localVarQueryParameter['Mobile'] = mobile;
    }

    if (mail !== undefined) {
        localVarQueryParameter['Mail'] = mail;
    }

    if (title !== undefined) {
        localVarQueryParameter['Title'] = title;
    }

    if (groupId !== undefined) {
        localVarQueryParameter['GroupId'] = groupId;
    }

    if (siteId !== undefined) {
        localVarQueryParameter['SiteId'] = siteId;
    }

    if (active !== undefined) {
        localVarQueryParameter['Active'] = active;
    }

    if (page !== undefined) {
        localVarQueryParameter['Page'] = page;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUsersSearchPhoneNumberGet - axios parameter creator
 * 
 * @summary  (Auth policies: Aut:GetUser)
 * @param {string} [phoneNumber] 
 * @param {UserSite} [userSite] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUsersSearchPhoneNumberGetAxiosParamCreator (phoneNumber?: string, userSite?: UserSite, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/users/search/phoneNumber`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (phoneNumber !== undefined) {
        localVarQueryParameter['phoneNumber'] = phoneNumber;
    }

    if (userSite !== undefined) {
        localVarQueryParameter['userSite'] = userSite;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUsersStaffGet - axios parameter creator
 * 
 * @summary  (Auth policies: auth:StaffUsers)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUsersStaffGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/users/staff`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUsersUserNotesGet - axios parameter creator
 * 
 * @summary  (Auth policies: auth:UserNote)
 * @param {number} userId 
 * @param {number} [page] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUsersUserNotesGetAxiosParamCreator (userId: number, page?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiUsersUserNotesGet', 'userId', userId)
    const localVarPath = `/api/users/UserNotes`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['UserId'] = userId;
    }

    if (page !== undefined) {
        localVarQueryParameter['Page'] = page;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUsersUserNotesIdDelete - axios parameter creator
 * 
 * @summary  (Auth policies: auth:UserNote)
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUsersUserNotesIdDeleteAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiUsersUserNotesIdDelete', 'id', id)
    const localVarPath = `/api/users/UserNotes/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiUsersUserNotesUserIdPost - axios parameter creator
 * 
 * @summary  (Auth policies: auth:UserNote)
 * @param {number} userId 
 * @param {AddUserNoteRequest} [addUserNoteRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiUsersUserNotesUserIdPostAxiosParamCreator (userId: number, addUserNoteRequest?: AddUserNoteRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiUsersUserNotesUserIdPost', 'userId', userId)
    const localVarPath = `/api/users/UserNotes/{userId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addUserNoteRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiApiV2UserMessagePost - axios parameter creator
 * 
 * @summary Receives a file and message and send it to all organization users with filters (Auth policies: Auth:SendMessageToUser)
 * @param {string} [fileUrl] 
 * @param {string} [text] 
 * @param {Array<number>} [userIds] 
 * @param {UserType} [organizationType] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiApiV2UserMessagePostAxiosParamCreator (fileUrl?: string, text?: string, userIds?: Array<number>, organizationType?: UserType, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/v2/User/message`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (fileUrl !== undefined) {
        localVarQueryParameter['FileUrl'] = fileUrl;
    }

    if (text !== undefined) {
        localVarQueryParameter['Text'] = text;
    }

    if (userIds) {
        localVarQueryParameter['UserIds'] = userIds;
    }

    if (organizationType !== undefined) {
        localVarQueryParameter['OrganizationType'] = organizationType;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserApiUserIsSpecialMobileGet - axios parameter creator
 * 
 * @param {string} mobile 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserApiUserIsSpecialMobileGetAxiosParamCreator (mobile: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'mobile' is not null or undefined
    assertParamExists('userIsSpecialMobileGet', 'mobile', mobile)
    const localVarPath = `/user/is-special/{mobile}`
        .replace(`{${"mobile"}}`, encodeURIComponent(String(mobile)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiAdminUsersGet operation in UserApi.
 * @export
 * @interface UserApiApiAdminUsersGetRequest
 */
export interface UserApiApiAdminUsersGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiAdminUsersGet
     */
    readonly userId: number

    /**
     * 
     * @type {boolean}
     * @memberof UserApiApiAdminUsersGet
     */
    readonly includePermissions?: boolean
}

/**
 * Request parameters for apiAssociateUUIDGet operation in UserApi.
 * @export
 * @interface UserApiApiAssociateUUIDGetRequest
 */
export interface UserApiApiAssociateUUIDGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiApiAssociateUUIDGet
     */
    readonly uuid?: string
}

/**
 * Request parameters for apiChangeUserPatch operation in UserApi.
 * @export
 * @interface UserApiApiChangeUserPatchRequest
 */
export interface UserApiApiChangeUserPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiChangeUserPatch
     */
    readonly userId?: number

    /**
     * 
     * @type {RegisterRequest}
     * @memberof UserApiApiChangeUserPatch
     */
    readonly registerRequest?: RegisterRequest
}

/**
 * Request parameters for apiGetAssociatedUUIDsGet operation in UserApi.
 * @export
 * @interface UserApiApiGetAssociatedUUIDsGetRequest
 */
export interface UserApiApiGetAssociatedUUIDsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiApiGetAssociatedUUIDsGet
     */
    readonly uuid?: string
}

/**
 * Request parameters for apiGetDomesticCitiesProvinceIdGet operation in UserApi.
 * @export
 * @interface UserApiApiGetDomesticCitiesProvinceIdGetRequest
 */
export interface UserApiApiGetDomesticCitiesProvinceIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiGetDomesticCitiesProvinceIdGet
     */
    readonly provinceId: number
}

/**
 * Request parameters for apiGetuserGet operation in UserApi.
 * @export
 * @interface UserApiApiGetuserGetRequest
 */
export interface UserApiApiGetuserGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiGetuserGet
     */
    readonly userId?: number

    /**
     * 
     * @type {boolean}
     * @memberof UserApiApiGetuserGet
     */
    readonly includePermissions?: boolean
}

/**
 * Request parameters for apiSetUserAttributesGet operation in UserApi.
 * @export
 * @interface UserApiApiSetUserAttributesGetRequest
 */
export interface UserApiApiSetUserAttributesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiApiSetUserAttributesGet
     */
    readonly mobile?: string
}

/**
 * Request parameters for apiUserIdStatusPut operation in UserApi.
 * @export
 * @interface UserApiApiUserIdStatusPutRequest
 */
export interface UserApiApiUserIdStatusPutRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiUserIdStatusPut
     */
    readonly id: number

    /**
     * 
     * @type {UserStatusRequest}
     * @memberof UserApiApiUserIdStatusPut
     */
    readonly userStatusRequest?: UserStatusRequest
}

/**
 * Request parameters for apiUserPost operation in UserApi.
 * @export
 * @interface UserApiApiUserPostRequest
 */
export interface UserApiApiUserPostRequest {
    /**
     * 
     * @type {AddUserRequest}
     * @memberof UserApiApiUserPost
     */
    readonly addUserRequest?: AddUserRequest
}

/**
 * Request parameters for apiUserSendMessagePost operation in UserApi.
 * @export
 * @interface UserApiApiUserSendMessagePostRequest
 */
export interface UserApiApiUserSendMessagePostRequest {
    /**
     * 
     * @type {SendMessageRequest}
     * @memberof UserApiApiUserSendMessagePost
     */
    readonly sendMessageRequest?: SendMessageRequest
}

/**
 * Request parameters for apiUserSetFcmTokenPut operation in UserApi.
 * @export
 * @interface UserApiApiUserSetFcmTokenPutRequest
 */
export interface UserApiApiUserSetFcmTokenPutRequest {
    /**
     * 
     * @type {UserFcmTokenRequest}
     * @memberof UserApiApiUserSetFcmTokenPut
     */
    readonly userFcmTokenRequest?: UserFcmTokenRequest
}

/**
 * Request parameters for apiUserUserIdBlocklistPatch operation in UserApi.
 * @export
 * @interface UserApiApiUserUserIdBlocklistPatchRequest
 */
export interface UserApiApiUserUserIdBlocklistPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiUserUserIdBlocklistPatch
     */
    readonly userId: number

    /**
     * 
     * @type {boolean}
     * @memberof UserApiApiUserUserIdBlocklistPatch
     */
    readonly isBlocklist?: boolean
}

/**
 * Request parameters for apiUserUserIdPut operation in UserApi.
 * @export
 * @interface UserApiApiUserUserIdPutRequest
 */
export interface UserApiApiUserUserIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiUserUserIdPut
     */
    readonly userId: number

    /**
     * 
     * @type {UpdateUserRequest}
     * @memberof UserApiApiUserUserIdPut
     */
    readonly updateUserRequest?: UpdateUserRequest
}

/**
 * Request parameters for apiUsersOrganizationUserSearchGet operation in UserApi.
 * @export
 * @interface UserApiApiUsersOrganizationUserSearchGetRequest
 */
export interface UserApiApiUsersOrganizationUserSearchGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiApiUsersOrganizationUserSearchGet
     */
    readonly mobile?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiApiUsersOrganizationUserSearchGet
     */
    readonly title?: string

    /**
     * 
     * @type {boolean}
     * @memberof UserApiApiUsersOrganizationUserSearchGet
     */
    readonly active?: boolean

    /**
     * 
     * @type {SortColumns}
     * @memberof UserApiApiUsersOrganizationUserSearchGet
     */
    readonly sortColumn?: SortColumns

    /**
     * 
     * @type {boolean}
     * @memberof UserApiApiUsersOrganizationUserSearchGet
     */
    readonly sortByAsc?: boolean

    /**
     * 
     * @type {OrgType}
     * @memberof UserApiApiUsersOrganizationUserSearchGet
     */
    readonly organizationType?: OrgType

    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersOrganizationUserSearchGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersOrganizationUserSearchGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiUsersSearchGet operation in UserApi.
 * @export
 * @interface UserApiApiUsersSearchGetRequest
 */
export interface UserApiApiUsersSearchGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiApiUsersSearchGet
     */
    readonly mobile?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiApiUsersSearchGet
     */
    readonly mail?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiApiUsersSearchGet
     */
    readonly title?: string

    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersSearchGet
     */
    readonly groupId?: number

    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersSearchGet
     */
    readonly siteId?: number

    /**
     * 
     * @type {boolean}
     * @memberof UserApiApiUsersSearchGet
     */
    readonly active?: boolean

    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersSearchGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersSearchGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiUsersSearchPhoneNumberGet operation in UserApi.
 * @export
 * @interface UserApiApiUsersSearchPhoneNumberGetRequest
 */
export interface UserApiApiUsersSearchPhoneNumberGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiApiUsersSearchPhoneNumberGet
     */
    readonly phoneNumber?: string

    /**
     * 
     * @type {UserSite}
     * @memberof UserApiApiUsersSearchPhoneNumberGet
     */
    readonly userSite?: UserSite
}

/**
 * Request parameters for apiUsersUserNotesGet operation in UserApi.
 * @export
 * @interface UserApiApiUsersUserNotesGetRequest
 */
export interface UserApiApiUsersUserNotesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersUserNotesGet
     */
    readonly userId: number

    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersUserNotesGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersUserNotesGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiUsersUserNotesIdDelete operation in UserApi.
 * @export
 * @interface UserApiApiUsersUserNotesIdDeleteRequest
 */
export interface UserApiApiUsersUserNotesIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersUserNotesIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiUsersUserNotesUserIdPost operation in UserApi.
 * @export
 * @interface UserApiApiUsersUserNotesUserIdPostRequest
 */
export interface UserApiApiUsersUserNotesUserIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiApiUsersUserNotesUserIdPost
     */
    readonly userId: number

    /**
     * 
     * @type {AddUserNoteRequest}
     * @memberof UserApiApiUsersUserNotesUserIdPost
     */
    readonly addUserNoteRequest?: AddUserNoteRequest
}

/**
 * Request parameters for apiV2UserMessagePost operation in UserApi.
 * @export
 * @interface UserApiApiV2UserMessagePostRequest
 */
export interface UserApiApiV2UserMessagePostRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiApiV2UserMessagePost
     */
    readonly fileUrl?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiApiV2UserMessagePost
     */
    readonly text?: string

    /**
     * 
     * @type {Array<number>}
     * @memberof UserApiApiV2UserMessagePost
     */
    readonly userIds?: Array<number>

    /**
     * 
     * @type {UserType}
     * @memberof UserApiApiV2UserMessagePost
     */
    readonly organizationType?: UserType
}

/**
 * Request parameters for userIsSpecialMobileGet operation in UserApi.
 * @export
 * @interface UserApiUserIsSpecialMobileGetRequest
 */
export interface UserApiUserIsSpecialMobileGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiUserIsSpecialMobileGet
     */
    readonly mobile: string
}

/**
* 
* @summary  (Auth policies: Aut:GetUser)
* @param {UserApiApiAdminUsersGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiAdminUsersGet(requestParameters: UserApiApiAdminUsersGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiAdminUsersGetAxiosParamCreator(requestParameters.userId, requestParameters.includePermissions, options, configuration);
    const request: () => AxiosPromise<UserView> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserApiApiAssociateUUIDGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiAssociateUUIDGet(requestParameters: UserApiApiAssociateUUIDGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiAssociateUUIDGetAxiosParamCreator(requestParameters.uuid, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {UserApiApiChangeUserPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiChangeUserPatch(requestParameters: UserApiApiChangeUserPatchRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiChangeUserPatchAxiosParamCreator(requestParameters.userId, requestParameters.registerRequest, options, configuration);
    const request: () => AxiosPromise<UpdateUserResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiGetAcquaintanceMethodsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiGetAcquaintanceMethodsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<AcquaintanceMethod>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: aut:GetAssociatedGuids)
* @param {UserApiApiGetAssociatedUUIDsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiGetAssociatedUUIDsGet(requestParameters: UserApiApiGetAssociatedUUIDsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiGetAssociatedUUIDsGetAxiosParamCreator(requestParameters.uuid, options, configuration);
    const request: () => AxiosPromise<Array<string>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserApiApiGetDomesticCitiesProvinceIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiGetDomesticCitiesProvinceIdGet(requestParameters: UserApiApiGetDomesticCitiesProvinceIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiGetDomesticCitiesProvinceIdGetAxiosParamCreator(requestParameters.provinceId, options, configuration);
    const request: () => AxiosPromise<Array<DomesticCityDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiGetProvincesGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiGetProvincesGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<ProvinceDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiGetWhyMrBilitGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiGetWhyMrBilitGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<WhyMrBilit>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserApiApiGetuserGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiGetuserGet(requestParameters: UserApiApiGetuserGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiGetuserGetAxiosParamCreator(requestParameters.userId, requestParameters.includePermissions, options, configuration);
    const request: () => AxiosPromise<UserView> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:ReadGroups)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiGroupsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiGroupsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<GroupsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserApiApiSetUserAttributesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiSetUserAttributesGet(requestParameters: UserApiApiSetUserAttributesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiSetUserAttributesGetAxiosParamCreator(requestParameters.mobile, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get all blocklist users (Auth policies: Auth:BlockUser)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUserBlocklistGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUserBlocklistGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<BlocklistUserResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary enable or disable a user.  if not stated will toggle the user\'s state (Auth policies: auth:ChangeUserStatus)
* @param {UserApiApiUserIdStatusPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUserIdStatusPut(requestParameters: UserApiApiUserIdStatusPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUserIdStatusPutAxiosParamCreator(requestParameters.id, requestParameters.userStatusRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary creating a new user (Auth policies: auth:UserCreation)
* @param {UserApiApiUserPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUserPost(requestParameters: UserApiApiUserPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUserPostAxiosParamCreator(requestParameters.addUserRequest, options, configuration);
    const request: () => AxiosPromise<Int32ResourceCreated> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Sets fcm token for the user (Auth policies: auth:SendMessageToUser)
* @param {UserApiApiUserSendMessagePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUserSendMessagePost(requestParameters: UserApiApiUserSendMessagePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUserSendMessagePostAxiosParamCreator(requestParameters.sendMessageRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Sets fcm token for the user (Auth)
* @param {UserApiApiUserSetFcmTokenPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUserSetFcmTokenPut(requestParameters: UserApiApiUserSetFcmTokenPutRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUserSetFcmTokenPutAxiosParamCreator(requestParameters.userFcmTokenRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Block or unblock a user (Auth policies: Auth:BlockUser)
* @param {UserApiApiUserUserIdBlocklistPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUserUserIdBlocklistPatch(requestParameters: UserApiApiUserUserIdBlocklistPatchRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUserUserIdBlocklistPatchAxiosParamCreator(requestParameters.userId, requestParameters.isBlocklist, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:AdminUserUpdate)
* @param {UserApiApiUserUserIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUserUserIdPut(requestParameters: UserApiApiUserUserIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUserUserIdPutAxiosParamCreator(requestParameters.userId, requestParameters.updateUserRequest, options, configuration);
    const request: () => AxiosPromise<AdminUpdateUserResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:OrganizationUserSearch)
* @param {UserApiApiUsersOrganizationUserSearchGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUsersOrganizationUserSearchGet(requestParameters: UserApiApiUsersOrganizationUserSearchGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUsersOrganizationUserSearchGetAxiosParamCreator(requestParameters.mobile, requestParameters.title, requestParameters.active, requestParameters.sortColumn, requestParameters.sortByAsc, requestParameters.organizationType, requestParameters.page, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<UserSearchViewPagedResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:UserSearch)
* @param {UserApiApiUsersSearchGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUsersSearchGet(requestParameters: UserApiApiUsersSearchGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUsersSearchGetAxiosParamCreator(requestParameters.mobile, requestParameters.mail, requestParameters.title, requestParameters.groupId, requestParameters.siteId, requestParameters.active, requestParameters.page, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<UserSearchViewPagedResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: Aut:GetUser)
* @param {UserApiApiUsersSearchPhoneNumberGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUsersSearchPhoneNumberGet(requestParameters: UserApiApiUsersSearchPhoneNumberGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUsersSearchPhoneNumberGetAxiosParamCreator(requestParameters.phoneNumber, requestParameters.userSite, options, configuration);
    const request: () => AxiosPromise<UserView> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:StaffUsers)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUsersStaffGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUsersStaffGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<StaffUsersResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:UserNote)
* @param {UserApiApiUsersUserNotesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUsersUserNotesGet(requestParameters: UserApiApiUsersUserNotesGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUsersUserNotesGetAxiosParamCreator(requestParameters.userId, requestParameters.page, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<Array<UserNoteResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:UserNote)
* @param {UserApiApiUsersUserNotesIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUsersUserNotesIdDelete(requestParameters: UserApiApiUsersUserNotesIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUsersUserNotesIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: auth:UserNote)
* @param {UserApiApiUsersUserNotesUserIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiUsersUserNotesUserIdPost(requestParameters: UserApiApiUsersUserNotesUserIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiUsersUserNotesUserIdPostAxiosParamCreator(requestParameters.userId, requestParameters.addUserNoteRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Receives a file and message and send it to all organization users with filters (Auth policies: Auth:SendMessageToUser)
* @param {UserApiApiV2UserMessagePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiApiV2UserMessagePost(requestParameters: UserApiApiV2UserMessagePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiApiV2UserMessagePostAxiosParamCreator(requestParameters.fileUrl, requestParameters.text, requestParameters.userIds, requestParameters.organizationType, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserApiUserIsSpecialMobileGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserApiUserIsSpecialMobileGet(requestParameters: UserApiUserIsSpecialMobileGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserApiUserIsSpecialMobileGetAxiosParamCreator(requestParameters.mobile, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
